<template>
  <v-main>
    <TabbedInterface
      class="clean maxh-1bar"
      ref="interface"
      title="Veículo"
      :tabComponents="allTabComponents"
      :value="vehicle"
      @reload="reload"
      orientation="vertical"
    >
      <template v-slot:sidebar-title>
        <SidebarHeaders :headers="headers" class="mt-1 pa-2" />
      </template>
    </TabbedInterface>
  </v-main>
</template>

<script>
import TabbedInterface from 'oderon-vue/cpts/tabbed-interface/TabbedInterface.vue'
import SidebarHeaders from 'oderon-vue/cpts/tabbed-interface/SidebarHeaders.vue'
import { Org, Vehicle } from '@/models'

import VehicleOverviewTab from './VehicleOverviewTab.vue'
import VehicleWifiTab from './VehicleWifiTab.vue'
import VehicleTripsTab from './VehicleTripsTab.vue'
import VehicleRDEventsTab from './VehicleRDEventsTab.vue'
import VehicleOccursTab from './VehicleOccursTab.vue'

export default {
  components: { TabbedInterface, SidebarHeaders },
  props: {
    vehicleId: { required: true }
  },
  data() {
    return {
      vehicle: null,
      org: null
    }
  },
  watch: {
    vehicleId() {
      this.reload()
    }
  },
  mounted() {
    this.reload()
  },
  computed: {
    allTabComponents() {
      return [
        VehicleOverviewTab,
        VehicleWifiTab,
        VehicleTripsTab,
        VehicleRDEventsTab,
        VehicleOccursTab
      ]
    },
    headers() {
      if (this.org == null || this.vehicle == null) return []
      const orgId = this.org.id
      const clientId = this.vehicle.clientId

      return [
        {
          icon: 'mdi-car',
          text: this.vehicle.code,
          primary: true,
          action: '#' + this.vehicle.idInOrg
        },
        {
          icon: 'mdi-developer-board',
          text: clientId || '(sem módulo)',
          path: clientId ? '/clients/' + clientId : null,
          action: clientId ? '#' + clientId : ''
        },
        {
          icon: 'mdi-domain',
          text: this.org.label,
          path: orgId == -1 ? null : '/orgs/' + orgId,
          action: orgId == -1 ? '' : '#' + orgId
        }
      ]
    }
  },
  methods: {
    reload() {
      this.$refs.interface.$loading(() => this.fetchData())
    },
    async fetchData() {
      const vehicle = await Vehicle.findById(this.vehicleId)
      const configs = await Vehicle.getConfigs(this.vehicleId)
      vehicle.configs = configs
      const org = await Org.findById(vehicle.orgId)

      let v = vehicle.code
      let o = org.label
      this.$setTitle(`${v} ─ ${o}`)

      this.vehicle = vehicle
      this.org = org
    }
  }
}
</script>

<style></style>
